import * as React from "react";
const SvgFiRrBee = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-bee_svg__a)">
      <path
        fill="#062147"
        d="M22.736 9.473c-1.342-1.371-4.464-2.078-7.639-2.345a3.501 3.501 0 0 0-1.242-4.594C14.342 2.245 15.037 2 15.999 2a1 1 0 1 0 0-2c-1.979 0-3.25.749-4 1.437C11.249.75 9.978 0 7.999 0a1 1 0 1 0 0 2c.96 0 1.657.245 2.144.534a3.5 3.5 0 0 0-1.242 4.594c-3.175.266-6.296.974-7.64 2.345-1.679 1.717-1.679 4.51.001 6.226A4.28 4.28 0 0 0 4.339 17a4.27 4.27 0 0 0 2.909-1.137c.527 2.748 1.783 5.67 2.717 7.053a2.45 2.45 0 0 0 4.066.001c.934-1.384 2.19-4.306 2.717-7.054A4.27 4.27 0 0 0 19.657 17a4.28 4.28 0 0 0 3.077-1.301c1.68-1.716 1.68-4.509 0-6.227zM12 4c.827 0 1.5.673 1.5 1.5S12.827 7 12 7s-1.5-.673-1.5-1.5S11.173 4 12 4m-.445 6.323.445-.62.445.62c.633.882 1.303 1.816 1.944 2.677H9.611c.641-.861 1.311-1.794 1.944-2.677M5.99 14.301c-.883.898-2.413.9-3.296 0a2.465 2.465 0 0 1 0-3.429c.762-.779 3.32-1.609 7.312-1.821-1.34 1.865-3.08 4.292-4.016 5.25m6.386 7.498a.44.44 0 0 1-.375.201.44.44 0 0 1-.375-.202c-.424-.628-.924-1.639-1.374-2.798h3.498c-.449 1.159-.95 2.17-1.374 2.799M14.422 17H9.58a17 17 0 0 1-.45-2h5.741a17 17 0 0 1-.45 2zm6.886-2.699c-.883.901-2.413.899-3.296 0-.937-.957-2.678-3.384-4.017-5.25 3.992.212 6.551 1.042 7.312 1.82a2.465 2.465 0 0 1 0 3.429z"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-bee_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrBee;
